import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

import { addressFormFields } from './addressFieldsForm';

const formFields = [
  ...addressFormFields,
  {
    name: 'occupancyType',
    label: 'Occupancy',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isTest',
    label: 'Test Lead',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const leadPropertyInformationForm = {
  name: FormNames.LEAD,
  label: 'Property Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
